export type MotorCause = {
  cause: string;
  probability: number;
};

export type MotorFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: MotorCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  MotorCause[],
  string[],
  string,
  string
];

const C = (
  cause: string,
  probability: number,
): MotorCause => ({
  cause,
  probability,
});

const rows: Row[] = [
[
  "motor-001",
  "المحرك الكهربائي",
  "المحرك ما يشتغل نهائياً",
  "تعطي أمر تشغيل بس المحرك ما يدور وماكو حركة.",
  "المحرك ما يشتغل",
  [C("ماكو تغذية واصلة للمحرك", 35), C("القاطع أو الفيوز فاصل", 25), C("الكونتاكتور أو دائرة السيطرة ما تشتغل", 20), C("أكو قطع بملفات المحرك", 20)],
  ["تأكد من مصدر التغذية والحمايات.", "افحص دائرة السيطرة والملفات بواسطة فني مؤهل."],
  "عالية",
  "محرك ما يشتغل motor not starting no start",
],
[
  "motor-002",
  "المحرك الكهربائي",
  "المحرك يطن وما يدور",
  "ينسمع طنين من المحرك بس الشفت ما يتحرك.",
  "المحرك يطن بدون دوران",
  [C("فاز مفقود بمحرك ثلاثي الفاز", 35), C("المحور أو الحمل محشور", 25), C("مكثف البدء خربان بمحرك أحادي الفاز", 25), C("الفولت واطي", 15)],
  ["وقف التشغيل حتى ما تحترك الملفات.", "افحص الفازات والحمل والمكثف حسب نوع المحرك."],
  "حرجة",
  "motor hums not turning locked rotor",
],
[
  "motor-003",
  "المحرك الكهربائي",
  "المحرك يتأخر حتى يشتغل",
  "المحرك يحتاج وقت أطول من الطبيعي حتى يوصل للدوران.",
  "تشغيل بطيء",
  [C("الفولت واطي", 30), C("الحمل ثقيل", 30), C("مكثف البدء ضعيف", 20), C("احتكاك ميكانيكي أو بيرنكات متعبة", 20)],
  ["خفف الحمل إذا ممكن.", "افحص الفولت ونظام البدء والبيرنكات."],
  "عالية",
  "slow motor starting long acceleration",
],
[
  "motor-004",
  "الحماية",
  "القاطع يفصل فور تشغيل المحرك",
  "من تعطي أمر تشغيل، القاطع يفصل مباشرة.",
  "فصل فوري للقاطع",
  [C("شورت بالملفات أو الكيبل", 45), C("قفل ميكانيكي بالمحرك أو الحمل", 25), C("قاطع أصغر من المطلوب أو متضرر", 15), C("توصيل غلط", 15)],
  ["لا تعيد التشغيل بصورة متكررة.", "افحص الكيبل والملفات والحمل قبل إعادة التشغيل."],
  "حرجة",
  "motor breaker trips immediately short circuit",
],
[
  "motor-005",
  "الحماية",
  "القاطع يفصل بعد فترة من التشغيل",
  "المحرك يشتغل شوية وبعدها القاطع يفصل.",
  "فصل بعد تشغيل",
  [C("حمل زائد", 40), C("حرارة عالية بالمحرك", 25), C("الفولت غير طبيعي", 20), C("القاطع أو الربط بيه مشكلة", 15)],
  ["راجع الحمل والتيار الاسمي.", "افحص التهوية والحماية والتغذية."],
  "عالية",
  "motor breaker thermal trip after running",
],
[
  "motor-006",
  "الأوفرلود",
  "الأوفرلود يفصل باستمرار",
  "ريليه الأوفرلود يفصل المحرك كل فترة قصيرة.",
  "فصل متكرر للأوفرلود",
  [C("الحمل أعلى من تحمل المحرك", 45), C("فقدان فاز", 25), C("ضبط الأوفرلود مو مناسب", 20), C("المحرك بيه عطل داخلي", 10)],
  ["لا ترفع ضبط الأوفرلود عشوائياً.", "افحص الحمل والفازات والتيار وضبط الحماية."],
  "عالية",
  "motor overload relay trips repeatedly",
],
[
  "motor-007",
  "الأوفرلود",
  "الأوفرلود ما يقبل Reset",
  "بعد الفصل، الأوفرلود ما يرجع للوضع الطبيعي.",
  "الأوفرلود ما يرجع",
  [C("بعده حار ويحتاج يبرد", 40), C("العطل بالحمل بعده موجود", 30), C("آلية Reset متضررة", 30)],
  ["خلي المحرك مفصول.", "حدد سبب الفصل قبل إعادة التشغيل."],
  "عالية",
  "motor overload will not reset",
],
[
  "motor-008",
  "الأوفرلود",
  "ضبط الأوفرلود مو مناسب للمحرك",
  "الحماية تفصل زيادة أو ما تفصل بالوقت الصحيح.",
  "حماية الحمل مو مضبوطة",
  [C("الإعداد أقل من تيار المحرك الاسمي", 45), C("الإعداد أعلى من المطلوب", 35), C("اختيار أوفرلود مو مناسب", 20)],
  ["راجع بيانات لوحة المحرك.", "خلي ضبط الحماية حسب المحرك وطريقة التشغيل."],
  "عالية",
  "motor overload setting incorrect",
],
[
  "motor-009",
  "التيار",
  "المحرك يسحب تيار عالي على كل الفازات",
  "التيار أعلى من الطبيعي على الفازات كلها.",
  "تيار عالي بكل الفازات",
  [C("حمل ميكانيكي زائد", 40), C("الفولت واطي", 25), C("احتكاك أو بيرنكات متعبة", 20), C("مشكلة بالملفات", 15)],
  ["افحص الحمل والجزء الميكانيكي.", "قارن تيار التشغيل ببيانات المحرك بواسطة فني مؤهل."],
  "عالية",
  "motor high current all phases",
],
[
  "motor-010",
  "التيار",
  "فاز واحد يسحب تيار أعلى من الباقي",
  "قراءة التيار على فاز تختلف بشكل واضح عن الفازات الثانية.",
  "عدم توازن تيار",
  [C("فولت الفازات مو متوازن", 35), C("ربط أحد الفازات ضعيف", 30), C("مشكلة بملف من ملفات الستاتور", 25), C("كونتاكت متضرر", 10)],
  ["افحص توازن الفولت والربطات.", "افحص ملفات المحرك إذا التغذية سليمة."],
  "حرجة",
  "motor phase current imbalance",
],
[
  "motor-011",
  "التيار",
  "تيار المحرك عالي حتى بدون حمل",
  "المحرك مفصول عن الحمل تقريباً لكن التيار بعده أعلى من الطبيعي.",
  "تيار لا حمل عالي",
  [C("توصيل الملفات غلط", 30), C("فولت غير مناسب", 25), C("احتكاك داخلي", 25), C("عطل بالملفات أو الحديد", 20)],
  ["افحص طريقة ربط ستار ودلتا حسب لوحة المحرك.", "افحص المحرك ميكانيكياً وكهربائياً."],
  "عالية",
  "motor high no load current",
],
[
  "motor-012",
  "التغذية ثلاثية الفاز",
  "فاز مفقود عن المحرك",
  "المحرك يشتغل على فازين أو يحاول يشتغل ويطن.",
  "فقدان فاز",
  [C("فيوز فاز محترق", 35), C("كونتاكت بالكونتاكتور متضرر", 30), C("سلك أو ترمنل مقطوع", 20), C("انقطاع من المصدر", 15)],
  ["وقف المحرك فوراً.", "افحص الفيوزات والكونتاكتور والكيبلات."],
  "حرجة",
  "motor phase loss single phasing",
],
[
  "motor-013",
  "التغذية ثلاثية الفاز",
  "الفولت بين الفازات مو متوازن",
  "الفولت يختلف بين فاز وفاز بصورة واضحة.",
  "عدم توازن الفولت",
  [C("مشكلة بالمصدر", 40), C("حمل الشبكة مو متوازن", 30), C("ربط أو كيبل بأحد الفازات ضعيف", 30)],
  ["لا تستمر بتشغيل المحرك إذا عدم التوازن واضح.", "خلي فني يفحص المصدر والربطات."],
  "حرجة",
  "motor voltage unbalance",
],
[
  "motor-014",
  "التغذية",
  "الفولت واطي على المحرك",
  "الفولت الواصل للمحرك أقل من المطلوب.",
  "انخفاض الفولت",
  [C("هبوط من المصدر", 35), C("كيبل طويل أو مقطعه صغير", 30), C("ربط مرخي", 20), C("حمل الشبكة عالي", 15)],
  ["افحص المصدر والكيبل والربطات.", "لا تحمل المحرك زيادة مع فولت واطي."],
  "عالية",
  "motor undervoltage low voltage",
],
[
  "motor-015",
  "التغذية",
  "الفولت عالي على المحرك",
  "الفولت الواصل للمحرك أعلى من الطبيعي.",
  "ارتفاع الفولت",
  [C("المصدر جاي عالي", 60), C("ضبط محولة أو منظومة تغذية غلط", 25), C("خطأ بقياس أو توصيل", 15)],
  ["افصل المحرك إذا الارتفاع قوي.", "افحص مصدر التغذية قبل إعادة التشغيل."],
  "حرجة",
  "motor overvoltage high voltage",
],
[
  "motor-016",
  "التغذية",
  "الفولت يصعد وينزل على المحرك",
  "الفولت مو ثابت ويتغير أثناء التشغيل.",
  "تذبذب الفولت",
  [C("المصدر مو مستقر", 40), C("ربط رئيسي مرخي", 30), C("حمل كبير يدخل ويطلع من الشبكة", 20), C("كيبل أو كونتاكت ضعيف", 10)],
  ["خلي المحرك تحت حماية مناسبة.", "افحص المصدر والربطات إذا التذبذب مستمر."],
  "عالية",
  "motor voltage fluctuation",
],
[
  "motor-017",
  "الاتجاه",
  "المحرك يدور بالعكس",
  "اتجاه دوران الشفت عكس الاتجاه المطلوب.",
  "دوران عكسي",
  [C("ترتيب الفازات متبدل بمحرك ثلاثي الفاز", 70), C("توصيل دائرة الاتجاه غلط", 30)],
  ["لا تبدل الفازات والمحرك تحت الكهرباء.", "خلي فني يصحح الترتيب بعد العزل."],
  "متوسطة",
  "motor reverse rotation phase sequence",
],
[
  "motor-018",
  "الاتجاه",
  "اتجاه المحرك يتغير بعد صيانة التوصيلات",
  "بعد تبديل كيبل أو كونتاكتور صار المحرك يدور بالعكس.",
  "الاتجاه تغير بعد الصيانة",
  [C("تم تبديل فازين", 80), C("توصيل دائرة Forward Reverse غلط", 20)],
  ["راجع مخطط التوصيل.", "صحح تسلسل الفازات بعد فصل التغذية."],
  "متوسطة",
  "motor direction changed after maintenance",
],
[
  "motor-019",
  "السرعة",
  "سرعة المحرك أقل من الطبيعي",
  "المحرك يدور بس سرعته أقل من المتوقع.",
  "سرعة المحرك واطية",
  [C("الحمل ثقيل", 30), C("الفولت واطي", 25), C("فقدان فاز أو عدم توازن", 20), C("مشكلة بالروتر", 15), C("تردد التغذية أقل من المطلوب", 10)],
  ["افحص الحمل والتغذية.", "افحص الروتر إذا الكهرباء سليمة."],
  "عالية",
  "motor low speed under load",
],
[
  "motor-020",
  "السرعة",
  "المحرك ما يوصل للسرعة المطلوبة",
  "يبقى يتسارع ببطء أو يثبت على سرعة أقل.",
  "ما يوصل للسرعة الاسمية",
  [C("الحمل أكبر من عزم المحرك", 35), C("الفولت واطي", 25), C("مشكلة بنظام البدء", 20), C("روتر أو بيرنكات بيها مشكلة", 20)],
  ["خفف الحمل للتجربة بواسطة فني.", "افحص التغذية ونظام البدء والحركة الميكانيكية."],
  "عالية",
  "motor cannot reach rated speed",
],
[
  "motor-021",
  "الحمل",
  "المحرك يوقف من يزيد الحمل",
  "المحرك يشتغل بحمل خفيف بس يوقف أو يهبط من يزيد الحمل.",
  "المحرك ما يتحمل الحمل",
  [C("المحرك أصغر من الحمل", 35), C("الفولت واطي", 25), C("عزم المحرك ضعيف بسبب عطل", 25), C("حمل ميكانيكي محشور", 15)],
  ["راجع قدرة المحرك والحمل.", "افحص التيار والتغذية والجزء الميكانيكي."],
  "عالية",
  "motor stalls under load",
],
[
  "motor-022",
  "العزم",
  "عزم المحرك ضعيف",
  "المحرك يدور بس القوة اللي يطلعها أقل من الطبيعي.",
  "ضعف العزم",
  [C("فولت واطي", 30), C("فقدان فاز جزئي أو عدم توازن", 25), C("توصيل ستار بدل دلتا بغير مكانه", 25), C("مشكلة بالروتر", 20)],
  ["راجع طريقة الربط وبيانات المحرك.", "افحص التغذية والروتر."],
  "عالية",
  "motor low torque weak torque",
],
[
  "motor-023",
  "الحرارة",
  "حرارة المحرك ترتفع بسرعة",
  "جسم المحرك ترتفع حرارته خلال وقت أقصر من الطبيعي.",
  "ارتفاع حرارة المحرك",
  [C("حمل زائد", 35), C("التهوية ضعيفة", 25), C("عدم توازن فازات", 20), C("بيرنكات متعبة", 10), C("ملفات متضررة", 10)],
  ["خفف الحمل ووقف التشغيل إذا الحرارة قوية.", "افحص التهوية والفازات والبيرنكات."],
  "حرجة",
  "motor overheating high temperature",
],
[
  "motor-024",
  "الحرارة",
  "حرارة المحرك ترتفع حتى بدون حمل",
  "المحرك يشتغل بدون حمل تقريباً بس حرارته ترتفع.",
  "حرارة عالية بدون حمل",
  [C("توصيل الملفات غلط", 30), C("فولت غير مناسب", 25), C("احتكاك داخلي", 25), C("مشكلة بالحديد أو الملفات", 20)],
  ["افحص طريقة الربط حسب لوحة المحرك.", "افحص الدوران الحر والتيار."],
  "عالية",
  "motor overheating no load",
],
[
  "motor-025",
  "الحرارة",
  "حرارة المحرك ترتفع بعد تشغيل متكرر",
  "المحرك يسخن بسرعة بسبب تشغيل وإيقاف متقارب.",
  "الحرارة ترتفع ويا كثرة التشغيل",
  [C("عدد مرات التشغيل أكثر من تصميم المحرك", 50), C("الحمل ثقيل وقت البدء", 30), C("زمن التسارع طويل", 20)],
  ["قلل مرات التشغيل المتقاربة.", "راجع طريقة التشغيل وقدرة المحرك."],
  "عالية",
  "motor frequent starts overheating",
],
[
  "motor-026",
  "التبريد",
  "مروحة تبريد المحرك مكسورة",
  "مروحة التبريد الخلفية مكسورة أو ناقصة ريش.",
  "التبريد ضعيف",
  [C("كسر ميكانيكي بالمروحة", 60), C("غطاء المروحة لامسها", 25), C("تثبيت المروحة مرخي", 15)],
  ["وقف المحرك إذا الحرارة ترتفع.", "بدل المروحة وصلح سبب الكسر."],
  "عالية",
  "motor cooling fan broken",
],
[
  "motor-027",
  "التبريد",
  "مجرى تهوية المحرك مسدود",
  "الغبار أو الأوساخ مسددة فتحات دخول أو خروج الهواء.",
  "التهوية مسدودة",
  [C("تراكم غبار", 60), C("زيوت وأوساخ على جسم المحرك", 25), C("تركيب المحرك بمكان تهويته ضعيفة", 15)],
  ["نظف فتحات التهوية بعد فصل التغذية.", "حسن التهوية حول المحرك."],
  "عالية",
  "motor ventilation blocked dust",
],
[
  "motor-028",
  "التبريد",
  "مروحة تبريد مستقلة ما تشتغل",
  "المحركات اللي بيها Forced Ventilation مروحتها الخارجية متوقفة.",
  "مروحة التبريد الخارجية متوقفة",
  [C("ماكو تغذية للمروحة", 40), C("موتور المروحة خربان", 35), C("حماية المروحة فاصل", 25)],
  ["وقف الحمل إذا المحرك يعتمد على هالمروحة.", "افحص تغذية وموتور مروحة التبريد."],
  "عالية",
  "motor forced cooling fan not working",
],
[
  "motor-029",
  "البيرنكات",
  "صوت البيرنك عالي",
  "ينسمع حنة أو خشونة من جهة البيرنك.",
  "صوت بيرنك غير طبيعي",
  [C("البيرنك متآكل", 50), C("التشحيم ناقص أو غير مناسب", 25), C("المحاذاة مو صحيحة", 15), C("تلوث داخل البيرنك", 10)],
  ["لا تهمل الصوت إذا يزيد بسرعة.", "افحص البيرنك والتشحيم والمحاذاة."],
  "عالية",
  "motor bearing noise",
],
[
  "motor-030",
  "البيرنكات",
  "حرارة البيرنك ترتفع",
  "منطقة البيرنك ترتفع حرارتها أكثر من الطبيعي.",
  "ارتفاع حرارة البيرنك",
  [C("شحوم زيادة", 30), C("شحوم قليلة أو ناشفة", 30), C("البيرنك متضرر", 25), C("المحاذاة مو صحيحة", 15)],
  ["راجع نوع وكمية الشحم.", "افحص البيرنك والمحاذاة."],
  "عالية",
  "motor bearing overheating",
],
[
  "motor-031",
  "البيرنكات",
  "البيرنك محشور",
  "الشفت ما يدور بحرية أو يوقف بسبب البيرنك.",
  "المحور ثقيل أو مقفول",
  [C("البيرنك انهار داخلياً", 55), C("ماكو تشحيم", 25), C("دخول أوساخ أو ماء", 20)],
  ["لا تحاول تشغل المحرك.", "بدل البيرنك وافحص الشفت ومكانه."],
  "حرجة",
  "motor bearing seized locked",
],
[
  "motor-032",
  "التشحيم",
  "الشحم زايد داخل البيرنك",
  "كمية الشحم أكبر من المطلوب وتسبب حرارة ومقاومة.",
  "حرارة بعد التشحيم",
  [C("تم ملء بيت البيرنك زيادة", 70), C("طريقة التشحيم مو صحيحة", 30)],
  ["استخدم الكمية والنوع المناسبين حسب تعليمات المحرك.", "لا تضيف شحم زيادة حتى تحل الحرارة."],
  "متوسطة",
  "motor bearing overgreasing",
],
[
  "motor-033",
  "التشحيم",
  "التشحيم قليل أو ناشف",
  "البيرنك يشتغل بتشحيم غير كافي.",
  "صوت وحرارة من البيرنك",
  [C("ما صار تشحيم بوقته", 50), C("الشحم قديم أو ناشف", 30), C("تسريب الشحم", 20)],
  ["شحّم حسب توصية المصنع.", "افحص البيرنك إذا استمر الصوت أو الحرارة."],
  "متوسطة",
  "motor bearing under lubrication",
],
[
  "motor-034",
  "الاهتزاز",
  "اهتزاز المحرك عالي",
  "المحرك يهتز أكثر من الطبيعي أثناء التشغيل.",
  "اهتزاز قوي",
  [C("عدم اتزان بالروتر أو الكوبلن", 30), C("المحاذاة مو صحيحة", 25), C("قاعدة المحرك مرخية", 20), C("بيرنك متضرر", 15), C("شفت معوج", 10)],
  ["لا تستمر إذا الاهتزاز شديد.", "افحص التثبيت والمحاذاة والبيرنكات والاتزان."],
  "عالية",
  "motor high vibration",
],
[
  "motor-035",
  "المحاذاة",
  "المحرك مو بمحاذاة الحمل",
  "شفت المحرك وشفت الحمل مو على خط واحد مضبوط.",
  "Misalignment",
  [C("تركيب المحرك مو مضبوط", 50), C("القاعدة تحركت", 25), C("الكوبلن متضرر", 25)],
  ["صحح المحاذاة بأداة مناسبة.", "افحص الكوبلن والقاعدة بعد المحاذاة."],
  "عالية",
  "motor misalignment coupling",
],
[
  "motor-036",
  "القاعدة",
  "براغي قاعدة المحرك مرخية",
  "المحرك يتحرك أو يهتز لأن براغي التثبيت مو ثابتة.",
  "القاعدة تتحرك",
  [C("البراغي مرخية", 60), C("القاعدة أو الفريم متشقق", 25), C("اهتزاز مستمر فك الربط", 15)],
  ["وقف المحرك إذا الحركة قوية.", "ثبت القاعدة وافحص التشققات."],
  "عالية",
  "motor loose foundation bolts",
],
[
  "motor-037",
  "القاعدة",
  "أكو Soft Foot بقاعدة المحرك",
  "إحدى أرجل المحرك ما تلامس القاعدة مضبوط وتسبب التواء بعد الشد.",
  "المحرك يتغير اهتزازه بعد شد البراغي",
  [C("شيمات ناقصة أو مو مستوية", 55), C("القاعدة مو مستوية", 30), C("رجل المحرك متضررة", 15)],
  ["صحح مستوى القاعدة والشيمات.", "أعد المحاذاة بعد علاج الـ Soft Foot."],
  "متوسطة",
  "motor soft foot",
],
[
  "motor-038",
  "الشفت",
  "شفت المحرك معوج",
  "المحور مو مستقيم ويسبب اهتزاز وعدم انتظام.",
  "اهتزاز مرتبط بالدوران",
  [C("ضربة ميكانيكية", 45), C("تحميل أو شد جانبي عالي", 30), C("ضرر سابق بالبيرنك", 25)],
  ["لا تشغل المحرك بسرعات عالية.", "افحص استقامة الشفت وبدله أو أصلحه حسب الحالة."],
  "عالية",
  "motor bent shaft",
],
[
  "motor-039",
  "الروتر",
  "الروتر يحك بالستاتور",
  "ينسمع احتكاك داخلي أو يصير تدوير الشفت ثقيل.",
  "احتكاك داخلي",
  [C("بيرنك متضرر", 45), C("شفت معوج", 25), C("عدم تمركز الروتر", 20), C("ضرر ميكانيكي داخلي", 10)],
  ["وقف المحرك فوراً.", "افحص البيرنكات والروتر والستاتور."],
  "حرجة",
  "motor rotor rubbing stator",
],
[
  "motor-040",
  "الروتر",
  "قضبان الروتر مكسورة",
  "المحرك يعاني من ضعف عزم واهتزاز أو تيار غير مستقر.",
  "ضعف عزم مع اهتزاز",
  [C("إجهاد حراري وتشغيلات قاسية", 40), C("عمر طويل", 30), C("عيب أو ضرر بالروتر", 30)],
  ["افحص الروتر باختبارات مناسبة بواسطة ورشة مختصة.", "بدل أو صلح الروتر إذا تأكد العطل."],
  "عالية",
  "broken rotor bars induction motor",
],
[
  "motor-041",
  "الكوبلن",
  "الكوبلن متضرر",
  "الكوبلن بيه تآكل أو تشقق أو فراغ ويسبب صوت واهتزاز.",
  "صوت أو اهتزاز من الكوبلن",
  [C("المحاذاة مو صحيحة", 40), C("القطعة المطاطية أو الأسنان متآكلة", 35), C("تحميل صدمات", 25)],
  ["بدل أجزاء الكوبلن المتضررة.", "صحح المحاذاة قبل التشغيل."],
  "عالية",
  "motor coupling damaged",
],
[
  "motor-042",
  "الكوبلن",
  "مفتاح الشفت أو Key مرخي",
  "الـ Key أو تثبيت الكوبلن على الشفت بيه فراغ.",
  "طك أو حركة بالكوبلن",
  [C("تآكل الـ Key أو المجرى", 50), C("برغي التثبيت مرخي", 30), C("تحميل صدمات", 20)],
  ["وقف المحرك قبل تفاقم الضرر.", "صلح أو بدل الـ Key والكوبلن حسب الحاجة."],
  "عالية",
  "motor shaft key loose coupling",
],
[
  "motor-043",
  "السيور",
  "السير مرخي وينزلق",
  "السير يزلق على البكرة وما ينقل العزم مضبوط.",
  "انزلاق السير",
  [C("شد السير قليل", 55), C("السير متآكل", 30), C("البكرات مو بمحاذاة", 15)],
  ["اضبط شد السير ضمن المطلوب.", "بدل السير إذا متآكل وصحح محاذاة البكرات."],
  "متوسطة",
  "motor belt loose slipping",
],
[
  "motor-044",
  "السيور",
  "السير مشدود زيادة",
  "شد السير عالي ويسبب حمل جانبي على البيرنكات.",
  "حرارة بيرنكات أو صوت بعد شد السير",
  [C("تم شد السير أكثر من المطلوب", 70), C("اختيار سير أو بكرات مو مناسب", 30)],
  ["خفف الشد حسب المواصفات.", "افحص البيرنكات إذا صار تشغيل طويل بهالحالة."],
  "عالية",
  "motor belt too tight bearing load",
],
[
  "motor-045",
  "البكرات",
  "البكرات مو بمحاذاة",
  "بكرة المحرك وبكرة الحمل مو على نفس الخط.",
  "تآكل سير واهتزاز",
  [C("تركيب البكرة مو مضبوط", 55), C("تحرك قاعدة المحرك", 25), C("بكرة أو شفت متضرر", 20)],
  ["صحح محاذاة البكرات.", "افحص تثبيت القاعدة والبكرة."],
  "متوسطة",
  "motor pulley misalignment",
],
[
  "motor-046",
  "علبة التوصيل",
  "حرارة ترمنلات المحرك ترتفع",
  "حرارة نقاط الربط داخل علبة التوصيل ترتفع.",
  "ارتفاع حرارة الترمنلات",
  [C("ربط مرخي", 55), C("اللگ مو مناسب", 25), C("تيار عالي", 20)],
  ["افصل التغذية قبل فتح علبة التوصيل.", "صحح الربط وبدل اللگ إذا متضرر."],
  "حرجة",
  "motor terminal overheating loose connection",
],
[
  "motor-047",
  "علبة التوصيل",
  "أكو حرك بعلبة توصيل المحرك",
  "تظهر آثار اسوداد أو ذوبان داخل الترمينال بوكس.",
  "آثار احتراق بالتوصيلات",
  [C("ربط مرخي", 45), C("شورت أو قوس كهربائي", 35), C("تيار أعلى من تحمل الترمنل", 20)],
  ["خلي المحرك مفصول.", "بدل القطع المحترقة وافحص سبب التيار أو القوس."],
  "حرجة",
  "motor terminal box burning arcing",
],
[
  "motor-048",
  "علبة التوصيل",
  "ربط ستار ودلتا غلط",
  "الجسور داخل علبة التوصيل مو متوافقة ويا فولت وطريقة تشغيل المحرك.",
  "تيار أو عزم مو طبيعي",
  [C("الجسور مركبة بطريقة غلط", 60), C("قراءة لوحة المحرك انفهَمت غلط", 25), C("مخطط التشغيل مو مطابق", 15)],
  ["راجع لوحة بيانات المحرك ومخطط التشغيل.", "لا تغير الجسور والمحرك تحت الكهرباء."],
  "حرجة",
  "motor star delta terminal connection wrong",
],
[
  "motor-049",
  "ستار دلتا",
  "المحرك يشتغل ستار بس يفصل من يتحول دلتا",
  "وقت التحويل من Star إلى Delta يصير فصل.",
  "الفصل عند التحويل لدلتا",
  [C("توصيل دلتا غلط", 35), C("كونتاكتور دلتا متضرر", 25), C("التايمر يحول بوقت مو مناسب", 20), C("مشكلة بالملفات أو الحمل", 20)],
  ["خلي المحرك مفصول لحد فحص مخطط ستار دلتا.", "افحص الكونتاكتورات والتايمر والربط."],
  "حرجة",
  "star delta motor trips on delta transition",
],
[
  "motor-050",
  "ستار دلتا",
  "المحرك يبقى على ستار وما يتحول دلتا",
  "التشغيل يبقى على Star وما يصير انتقال لـ Delta.",
  "ماكو تحويل لدلتا",
  [C("تايمر ستار دلتا متضرر", 40), C("كونتاكتور دلتا ما يسحب", 35), C("دائرة interlock أو السيطرة مفتوحة", 25)],
  ["افحص التايمر ودائرة السيطرة.", "لا تحمل المحرك زيادة إذا بقى على ستار."],
  "عالية",
  "star delta motor stuck in star",
],
[
  "motor-051",
  "ستار دلتا",
  "كونتاكتور ستار ودلتا يسحبن سوه",
  "يظهر أمر خطير لأن كونتاكتور Star وDelta يصيرن ON بنفس الوقت.",
  "ستار ودلتا بنفس الوقت",
  [C("Interlock كهربائي أو ميكانيكي متضرر", 50), C("توصيل دائرة السيطرة غلط", 30), C("كونتاكتور عالق", 20)],
  ["افصل التغذية فوراً.", "لا ترجع التشغيل قبل إصلاح الـ interlock ودائرة السيطرة."],
  "حرجة",
  "star delta contactors simultaneous interlock failure",
],
[
  "motor-052",
  "ستار دلتا",
  "زمن التحويل من ستار لدلتا مو مناسب",
  "المحرك يتحول بسرعة زيادة أو يتأخر زيادة.",
  "صدمة أو هبوط سرعة وقت التحويل",
  [C("ضبط التايمر مو مناسب", 60), C("الحمل يحتاج زمن تسارع مختلف", 25), C("دائرة التايمر متضررة", 15)],
  ["اضبط الزمن حسب المحرك والحمل بواسطة فني.", "راقب تيار وسرعة التسارع بطريقة آمنة."],
  "متوسطة",
  "star delta timer incorrect",
],
[
  "motor-053",
  "المحركات أحادية الفاز",
  "مكثف البدء خربان",
  "المحرك يطن وما يبدأ أو يحتاج دفعة حتى يدور.",
  "المحرك يحتاج دفعة أو يطن",
  [C("مكثف البدء مفتوح أو ضعيف", 70), C("سويتش البدء ما يشتغل", 20), C("ملف البدء متضرر", 10)],
  ["وقف التشغيل إذا المحرك يطن.", "افحص المكثف ودائرة البدء بعد فصل التغذية وتفريغ المكثف بطريقة آمنة."],
  "عالية",
  "single phase motor start capacitor failed",
],
[
  "motor-054",
  "المحركات أحادية الفاز",
  "مكثف التشغيل ضعيف",
  "المحرك يشتغل بس العزم أو الأداء ضعيف وحرارته ممكن ترتفع.",
  "ضعف أداء بمحرك أحادي الفاز",
  [C("مكثف التشغيل فقد سعته", 70), C("الفولت مو مناسب", 20), C("حمل المحرك عالي", 10)],
  ["افحص المكثف بقيمة مناسبة بعد العزل.", "بدله بنفس التصنيف الصحيح إذا تأكد العطل."],
  "عالية",
  "single phase run capacitor weak",
],
[
  "motor-055",
  "المحركات أحادية الفاز",
  "المكثف منتفخ أو يسرب",
  "شكل المكثف متغير أو أكو تسريب من جسمه.",
  "تلف واضح بالمكثف",
  [C("حرارة عالية", 40), C("فولت أعلى من تحمل المكثف", 35), C("عمر المكثف انتهى", 25)],
  ["لا تستخدم المكثف المتضرر.", "بدله بنفس السعة والفولت والتصنيف المناسب."],
  "عالية",
  "motor capacitor bulged leaking",
],
[
  "motor-056",
  "المحركات أحادية الفاز",
  "سويتش الطرد المركزي ما يفصل",
  "دائرة البدء تبقى داخلة بعد وصول المحرك للسرعة.",
  "حرارة أو صوت غير طبيعي بعد البدء",
  [C("السويتش عالق", 55), C("الميكانيكية متسخة أو متضررة", 25), C("سرعة المحرك ما وصلت للمطلوب", 20)],
  ["وقف التشغيل إذا ترتفع الحرارة.", "افحص السويتش وآلية البدء."],
  "عالية",
  "centrifugal switch not opening motor",
],
[
  "motor-057",
  "المحركات أحادية الفاز",
  "سويتش الطرد المركزي ما يوصل وقت البدء",
  "ملف ومكثف البدء ما يدخلن بالدائرة وقت التشغيل.",
  "المحرك يطن وما يبدأ",
  [C("السويتش مفتوح أو متضرر", 60), C("آلية السويتش عالقة", 25), C("توصيل دائرة البدء مقطوع", 15)],
  ["خلي المحرك مفصول.", "افحص السويتش ودائرة البدء."],
  "عالية",
  "centrifugal switch not closing",
],
[
  "motor-058",
  "الملفات",
  "ملف البدء مقطوع",
  "دائرة ملف البدء بمحرك أحادي الفاز مفتوحة.",
  "المحرك يطن وما يبدأ",
  [C("احتراق ملف البدء", 60), C("سلك داخلي مقطوع", 25), C("ترمنل أو وصلة مفصولة", 15)],
  ["لا تستمر بمحاولات التشغيل.", "خلي ورشة مختصة تفحص الملف وتقرر الإصلاح."],
  "حرجة",
  "motor start winding open",
],
[
  "motor-059",
  "الملفات",
  "ملف التشغيل مقطوع",
  "أحد مسارات ملف التشغيل مفتوح وما يمر تيار طبيعي.",
  "المحرك ما يشتغل أو أداؤه غير طبيعي",
  [C("احتراق الملف", 60), C("قطع داخلي", 25), C("وصلة ترمنل مفصولة", 15)],
  ["افصل المحرك.", "افحص استمرارية الملفات بواسطة فني مختص."],
  "حرجة",
  "motor run winding open",
],
[
  "motor-060",
  "الملفات",
  "شورت بين لفات الملف",
  "جزء من لفات الستاتور صار بينه قصر داخلي.",
  "تيار عالي وحرارة مو طبيعية",
  [C("تدهور العزل بسبب الحرارة", 45), C("رطوبة أو تلوث", 25), C("فولت أو إجهاد كهربائي", 20), C("عمر العزل", 10)],
  ["خلي المحرك مفصول.", "يحتاج فحص ملفات بورشة مختصة وقد يحتاج إعادة لف."],
  "حرجة",
  "motor winding turn to turn short",
],
[
  "motor-061",
  "الملفات",
  "تسريب ملف المحرك للأرضي",
  "العزل بين الملفات وجسم المحرك ضعيف أو منهار.",
  "قاطع التسريب أو الحماية تفصل",
  [C("عزل الملفات متضرر", 50), C("رطوبة داخل المحرك", 30), C("تلوث أو زيت داخل الملفات", 20)],
  ["لا تشغل المحرك.", "خلي فني يقيس العزل بعد العزل الكامل من التغذية."],
  "حرجة",
  "motor winding ground fault insulation",
],
[
  "motor-062",
  "الملفات",
  "ملفات المحرك محترقة",
  "أكو ريحة حرك أو تغير لون واضح بالملفات والمحرك ما يشتغل طبيعي.",
  "ريحة حرك وملفات متضررة",
  [C("حمل زائد طويل", 35), C("فقدان فاز", 25), C("تهوية سيئة", 20), C("حماية مو مضبوطة", 20)],
  ["لا ترجع تشغيل المحرك.", "خلي ورشة مختصة تفحصه وقد يحتاج إعادة لف أو تبديل."],
  "حرجة",
  "motor burnt windings",
],
[
  "motor-063",
  "العزل",
  "مقاومة عزل المحرك واطية",
  "العزل بين الملفات والجسم أو بين الملفات مو بالمستوى المطلوب.",
  "قراءة عزل ضعيفة",
  [C("رطوبة", 40), C("تلوث بالغبار أو الزيت", 25), C("تقادم العزل", 20), C("ضرر حراري", 15)],
  ["لا تشغل المحرك إذا العزل غير مقبول.", "خلي فني مختص يعالج سبب الرطوبة أو التلوث ويفحصه."],
  "حرجة",
  "motor low insulation resistance",
],
[
  "motor-064",
  "الرطوبة",
  "ماي أو رطوبة داخل المحرك",
  "دخل ماي أو رطوبة لعلبة التوصيل أو الملفات.",
  "رطوبة داخل المحرك",
  [C("سيل أو جلدة متضررة", 40), C("مكان تركيب رطب", 30), C("غسل أو تكاثف", 30)],
  ["خلي المحرك مفصول.", "لا تشغله قبل التجفيف والفحص والعزل."],
  "حرجة",
  "motor moisture water ingress",
],
[
  "motor-065",
  "التأريض",
  "أرضي المحرك مقطوع أو مرخي",
  "سلك الأرضي أو نقطة ربطه بجسم المحرك مو ثابتة.",
  "تأريض المحرك مو سليم",
  [C("برغي الأرضي مرخي", 50), C("السلك مقطوع", 30), C("تآكل بنقطة الربط", 20)],
  ["لا تشغل المحرك بدون أرضي سليم.", "خلي فني يفحص استمرارية التأريض."],
  "حرجة",
  "motor grounding earth loose",
],
[
  "motor-066",
  "الكونتاكتور",
  "كونتاكتور المحرك ما يسحب",
  "تعطي Start بس الكونتاكتور ما يجذب.",
  "الكونتاكتور ما يشتغل",
  [C("ماكو فولت سيطرة", 40), C("ملف الكونتاكتور محترق", 35), C("سلسلة الحماية مفتوحة", 25)],
  ["افحص دائرة السيطرة والحمايات.", "إذا فولت الملف موجود والكونتاكتور ما يشتغل، افحصه."],
  "عالية",
  "motor contactor not pulling in",
],
[
  "motor-067",
  "الكونتاكتور",
  "كونتاكتور المحرك يطن أو يقطع",
  "الكونتاكتور يسحب ويفصل أو يطلع صوت قوي.",
  "تقطيع أو طنين بالكونتاكتور",
  [C("فولت السيطرة واطي أو متذبذب", 45), C("الكونتاكتور متضرر", 30), C("دائرة المسك بيها مشكلة", 25)],
  ["لا تخلي المحرك يشتغل بالتقطيع.", "افحص فولت السيطرة والكونتاكتور."],
  "عالية",
  "motor contactor chatter buzzing",
],
[
  "motor-068",
  "الكونتاكتور",
  "نقطة فاز بالكونتاكتور محترقة",
  "أحد الكونتاكتات الرئيسية محروق ويسبب فقدان أو ضعف فاز.",
  "فاز ضعيف أو مفقود بعد الكونتاكتور",
  [C("تآكل الكونتاكت", 45), C("ربط مرخي", 30), C("الحمل أعلى من تحمل الكونتاكتور", 25)],
  ["خلي المحرك مفصول.", "بدل الكونتاكتور أو الجزء المتضرر وافحص الحمل."],
  "حرجة",
  "motor contactor burnt contact phase loss",
],
[
  "motor-069",
  "الحمل الميكانيكي",
  "الحمل المربوط على المحرك محشور",
  "المحرك سليم تقريباً بس المعدة المربوطة بيه ما تتحرك بحرية.",
  "الحمل ثقيل أو مقفول",
  [C("بيرنك بالمعدة محشور", 35), C("مضخة أو مروحة بيها جسم غريب", 30), C("جيربوكس متضرر", 20), C("تحميل ميكانيكي غير طبيعي", 15)],
  ["افصل المحرك عن مصدر الطاقة قبل فحص الحمل.", "تأكد أن المعدة تدور بحرية حسب إجراءات السلامة."],
  "حرجة",
  "motor driven load jammed mechanical overload",
],
[
  "motor-070",
  "الحساس الحراري",
  "حساس حرارة المحرك PTC أو Thermistor يعطي عطل",
  "الحماية الحرارية تمنع التشغيل أو تعطي إنذار بصورة غير طبيعية.",
  "إنذار حرارة أو فصل بدون حرارة واضحة",
  [C("حرارة المحرك فعلاً عالية", 40), C("حساس PTC متضرر", 30), C("سلك الحساس مقطوع", 20), C("ريليه الحماية الحرارية متضرر", 10)],
  ["تأكد أولاً من حرارة المحرك الفعلية بطريقة آمنة.", "افحص الحساس وأسلاكه وريليه الحماية."],
  "عالية",
  "motor PTC thermistor thermal sensor fault",
],
];

export const motorFaults: MotorFault[] = rows.map(
  ([
    id,
    device_ar,
    name_ar,
    description_ar,
    symptom,
    causes,
    solutions,
    severity,
    keywords,
  ]) => {
    const critical = severity === "حرجة";

    return {
      id,
      category_id: null,
      device_ar,
      name_ar,
      description_ar,
      symptoms: [symptom],
      causes,
      tests: [
        {
          test: "الفحص الأولي",
          location: device_ar,
          method:
            "افصل التغذية واعزل المحرك والحمل قبل فتح علبة التوصيل أو لمس الشفت والأجزاء المتحركة. قياسات الفولت والتيار أثناء التشغيل، وقياسات العزل والملفات، تكون بواسطة فني كهربائي مؤهل وبمعدات مناسبة.",
          normal:
            "التغذية متوازنة، ماكو حرارة عالية أو ريحة حرك أو اهتزاز غير طبيعي، والشفت والحمل يشتغلن بصورة مستقرة.",
          faulty:
            "فقدان فاز أو تيار غير متوازن أو حرارة عالية أو صوت واهتزاز أو عزل ضعيف يدل على عطل يحتاج فحص وإصلاح.",
        },
      ],
      solutions,
      severity,
      safety_warnings: critical
        ? [
            "تنبيه: المحرك ممكن يسبب صعقة أو حركة مفاجئة أو إصابة ميكانيكية. اعزل مصدر الطاقة قبل الصيانة ولا تعتمد على زر Stop وحده.",
            "العمل على كهرباء حية أو اختبار ملفات وقدرة المحرك خليه لفني مؤهل.",
          ]
        : [
            "افصل التغذية قبل الفك أو لمس الشفت والكوبلن والسيور.",
            "إذا أكو ريحة حرك أو حرارة عالية أو شرر أو اهتزاز قوي، وقف المحرك قبل ما يتفاقم الضرر.",
          ],
      error_code: null,
      keywords,
      next_question_key: null,
    };
  },
);
